import React,{useEffect, useRef, useState} from 'react'
import Footer from '../../Components/Footer/Footer'
import Navbar from '../../Components/Navbar/Navbar'
import BookItem from '../../Components/BookItem/BookItem'
import './SearchResult.css'
import { useSelector } from 'react-redux'
import {  useNavigate, useParams } from 'react-router-dom'

import userApi from '../../Common/Api/UserApi'


const SearchResult = () => {
    const keypress = useRef();
    const navigate  = useNavigate();
    
    const [books, setBooks] = useState([{ images: ["./books/book1.jpg"], title: "Solitude Loves", price: "231", authors: ["J.K Rowling"], categories: ["Entertainment"] },{ images: ["./books/book1.jpg"], title: "Solitude Loves", price: "231", authors: ["J.K Rowling"], categories: ["Entertainment"] },{ images: ["./books/book1.jpg"], title: "Solitude Loves", price: "231", authors: ["J.K Rowling"], categories: ["Entertainment"] },{ images: ["./books/book1.jpg"], title: "Solitude Loves", price: "231", authors: ["J.K Rowling"], categories: ["Entertainment"] },{ images: ["./books/book1.jpg"], title: "Solitude Loves", price: "231", authors: ["J.K Rowling"], categories: ["Entertainment"] },{ images: ["./books/book1.jpg"], title: "Solitude Loves", price: "231", authors: ["J.K Rowling"], categories: ["Entertainment"] },{ images: ["./books/book1.jpg"], title: "Solitude Loves", price: "231", authors: ["J.K Rowling"], categories: ["Entertainment"] },]);

    const {Books} = useSelector((state)=>{
        return (state);
      })
      
    var {  category_id,category_name,title,location } = useParams();
    const {categories} = Books;

    const [categoryName,setCategoryName] = useState('Categories');

    const [searchInput,setSearchInput] = useState({title:'',category:''});

    const getBooks = async()=>{

        title = title.substring(1);
        category_id = category_id.substring(1);
        category_name = category_name.substring(1);
        location = location.substring(1);

        // console.log("title from home page",title,category,location);

        var res;
        if(category_name.length==0)
        {
            res = await userApi.post('/categories/filter',{
                categories:[category_id],
                // categories:['641571b11b98cbbf756512ce'],
                location:location,
                title:title
            })
        }
        else
            res = await userApi.get(`/categories/:${category_name}`);

        console.log("data received from categories route : ",res)
        setBooks(res.data.ads);
        // setBooks(data);

    }

    const selectCategory = (id)=>{
        setSearchInput({...searchInput,category:id});
    }
    const onTitleChange=(e)=>{
        e.preventDefault();

        setSearchInput({...searchInput,title:e.target.value});
    }

    const handleSearch = () => {
        console.log("searchInput",searchInput);
        navigate(`/search-result/:${searchInput.category}/:/:${searchInput.title}/:`);
    }

    useEffect(() => {
      
        getBooks();

    }, [title])
    useEffect(() => {
        const keyDownHandler = event => {
        console.log('User pressed: ', event.key);

        if (event.key === 'Enter') {
            event.preventDefault();
            keypress.current.click();
        //    handleSearch(event)
        }
    };

    document.addEventListener('keydown', keyDownHandler);

    return () => {
      document.removeEventListener('keydown', keyDownHandler);
    };
  });
  
  return (
    <div>
        <Navbar colorLeft="#5f2c3e" colorRight="#5f2c3e" />

        <div className="search-result-container">
            <div className='search-result-top'>

                <h4>Search Results for : {title.substring(1)} </h4>

                <div className='searchByCategories'>
                    <i class="fa-solid fa-list"></i>
                    <div>{categoryName}</div>
                    <i class="fa-solid fa-chevron-down"></i>

                    <div className='category-list-container'>

                        <div className='category-list'>
                        {
                            categories.map((element)=>{
                                // console.log("element",element)
                                return (
                                    <> 
                                    <div className='category-list-item' onClick={()=>{selectCategory(element._id); setCategoryName(element.name)}}>
                                        {element.name}
                                    </div>
                                    <hr />
                                    </>
                                )
                            })
                        }
                        </div>

                    </div>
      
                </div>

                <div className='search-box'>
                    <input type='search' placeholder='Search . . .' value={searchInput.title} onChange={onTitleChange}></input>
                    <i class="fa-solid fa-magnifying-glass" ref={keypress} onClick={handleSearch}></i>
                </div>

            </div>


            <div className='books-section row'>
            {
                      books.map((element) => { 
                          return (
                        element.sold === false &&
                        (<div className='col-lg-3 col-md-3 col-sm-6 col-xs-12 my-5'>
                            <BookItem  name={element.title} img={element.images[0]} price={element.price} author={element.authors[0]} category={element.categories[0]} id={element._id}/>
                        </div>)
                    )
                })
            }

            </div>


        </div>

        <Footer/>
    </div>
  )
}

export default SearchResult